import { Component, computed, inject, input, ChangeDetectionStrategy } from "@angular/core";
import { UtilityService } from "@eforall/common";
import { DialogService } from "@eforall/dashboard";
import { AIPromptDetails } from "@interfaces";
import { AccVentureDialog } from "../../acc-venture";

@Component({
	selector: 'advisor-prompt-response-or-error-part',
	standalone: true,
	imports: [],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './response-or-error.part.html'
})
export class AdvisorPromptResponseOrErrorPart {

	private util = inject(UtilityService);
	private dialog = inject(DialogService);
	public dialogData = input.required<AIPromptDetails>();

	public formattedDate = computed(() => {
		const data = this.dialogData();
		return this.util.date.formatUTC(data.createdUTC, 'MMM D, YYYY', 'H:MM AM EST', 'en-US');
	});

	openVentureDetails() {
		const data = this.dialogData();
		this.dialog.showCustom(AccVentureDialog, { data: { accVentureId: data.accVentureId } }, 900, 700);
	}
}